$(function() {
    // ajax params
    let myajax = `//${window.location.host}/wp-admin/admin-ajax.php`,
        paramObj = {
            action: 'load_post',
            postType: null,
            url: myajax,
            catId: 'all',
            currentPage: 1,
            order: 'DESC',
            quarter: '',
            type: '',
            market: '',
            productType: '',
            service: '',
            sector: '',
            location: ''
        };

    // Ajax helper functions
    function loadPosts(paramObj, target) {
        let $this = $(target),
            $isLoadMore = $this.hasClass('js-load-more');
        $.ajax({
            url: paramObj.url,
            data: paramObj,
            type: 'POST',
            beforeSend() {
                if ($isLoadMore) {
                    $this.find('.btn-inner').text('Loading');
                }
            },
            success(data) {
                if ($isLoadMore) {
                    $this.parents('.js-load-more-wrap').before(data);
                    $this.parents('.js-load-more-wrap').remove();
                    let maxPage = parseInt($this.data('max-page'));
                    if (paramObj.currentPage === maxPage) {
                        $('.js-load-more-wrap').remove();
                    }
                } else {
                    $('.js-articles-list, .js-projects-grid').html(data);
                }
            },
            complete() {
                if ($isLoadMore) {
                    $this.find('.btn-inner').text('Show more');
                }
            }
        });
    }

    //Load more
    $('.js-articles-list, .js-projects-grid').on('click', '.js-load-more', function H(e) {
        e.preventDefault();
        let $this = $(this),
            postType = $this.data('post-type'),
            catId = $this.data('cat-id'),
            current = parseInt($this.data('current-page'));
        paramObj.postType = postType;
        if(catId) {
            paramObj.catId = catId ? catId : 'all';
        }
        current = current + 1;
        paramObj.currentPage = current;
        loadPosts(paramObj, $this);
        console.log(paramObj);
    });

    //Filter
    $('.js-filter-select').on('change', function H() {
        let $this = $(this),
            $thisArea = $this.attr('data-area'),
            $thisVal = $this.val(),
            postType = $this.data('post-type');
        paramObj.postType = postType;
        paramObj.currentPage = 1;
        switch ($thisArea) {
            case 'order-sort':
                paramObj.order = $thisVal;
                break;
            case 'quarter':
                paramObj.quarter = $thisVal;
                break;
            case 'type':
                paramObj.type = $thisVal;
                break;
            case 'market':
                paramObj.market = $thisVal;
                break;
            case 'product-type':
                paramObj.productType = $thisVal;
                break;
            case 'service':
                paramObj.service = $thisVal;
                break;
            case 'sector':
                paramObj.sector = $thisVal;
                break;
            case 'location':
                paramObj.location = $thisVal;
                break;
            default:
                return;
        }
        loadPosts(paramObj, $this);
        console.log(paramObj);
    });
});